import InfoFrameIcon from './component'

export default InfoFrameIcon
